<template>
  <div
    v-if="isMobile"
    class="app-sidebar rooms-sidebar"
    :class="{
      open: isOpen,
      full: sidebarFull,
    }"
    v-click-outside="closeSidebarIfOpen"
  >
    <div class="app-sidebar__content">
      <template>
        <v-tooltip
          v-for="(link, idx) in filteredSections"
          :key="idx"
          :disabled="hideTooltips"
          right
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <a
                class="app-sidebar__link"
                :class="{
                  'chat-link': link.section === 'chat',
                  'router-link-active': link.section === currentSection,
                }"
                href="#"
                @click.prevent="setSection(link.section)"
              >
                <v-fade-transition>
                  <v-avatar
                    class="chat-link__count"
                    color="#cd5c5c"
                    :size="19"
                    v-if="link.section === 'chat' && unreadChatCount"
                  >
                    <span class="light--text">{{ unreadChatCount }}</span>
                  </v-avatar>
                </v-fade-transition>
                <div class="app-sidebar__link-icon">
                  <v-icon color="appMain">{{ link.icon }}</v-icon>
                </div>
                <span class="app-sidebar__link-text">
                  {{ link.text }}
                </span>
              </a>
            </div>
          </template>
          <span>
            {{ link.text }}
          </span>
        </v-tooltip>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { eventBus, trigger, on } from '@/lib/events';

export default {
  name: 'RoomsSidebar',
  components: {},
  data() {
    return {
      unreadChatCount: 0,
      currentSection: null,
      sections: [
        {
          text: 'My Meeting',
          icon: 'groups',
          section: 'participants',
        },
        {
          text: 'Controls',
          icon: 'video_camera_front',
          section: 'controls',
        },
        {
          text: 'Chat',
          icon: 'chat',
          section: 'chat',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['sidebarOpen']),

    isOpen() {
      return this.isMobile && this.sidebarOpen;
    },
    routeName() {
      return this.$route.name;
    },
    sidebarFull() {
      return this.sidebarOpen; //this.$route.path === '/' && !this.isMobile
    },
    filteredSections() {
      //todo only show participants if connected?
      return this.sections.slice(0);
      // return this.links.filter(i => !i.check || this.hasPermission(i.check))
    },
    hideTooltips() {
      return this.sidebarFull || this.isMobile;
    },
  },
  watch: {
    currentSection() {
      this.closeSidebar();
    },
  },
  methods: {
    ...mapMutations(['toggleSidebar']),
    closeSidebar() {
      if (!this.isOpen || !this.isMobile) return;
      this.toggleSidebar();
    },
    closeSidebarIfOpen(e) {
      if (!this.isOpen || !e.target) {
        return;
      }

      let header = e.target.closest('.app-header');

      if (!header) {
        this.closeSidebar();
      }
    },
    setSection(section) {
      eventBus.trigger('sectionShown', section);
    },
    subscribeToEvents() {
      eventBus
        .on('newChatMessage', () => {
          if (this.currentSection !== 'chat') {
            this.unreadChatCount += 1;
          }
        })
        .on('sendParticipantMessage', () => {
          if (this.isMobile) {
            eventBus.trigger('sectionShown', 'chat');
          }
        })
        .on('sectionShown', (section) => {
          this.currentSection = section;
          if (section === 'chat') {
            this.unreadChatCount = 0;
          }
        });
    },
  },
  created() {
    setTimeout(() => {
      this.setSection('controls');
      this.subscribeToEvents();
    });
  },
};
</script>

<style lang="less">
.chat-link {
  position: relative;
}

.chat-link__count {
  position: absolute !important;
  top: 3px;
  left: 21px;
  font-size: 12px;
  background-color: #fff;
  opacity: 1 !important;
  z-index: 1;
}
</style>

<style lang="less" src="@/assets/styles/app/app-sidebar.less"></style>
